import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import {
  SetSideNavCollapsedStateSetting,
  SetSideNavExpandedTile,
  SetSideNavSetting,
} from './side-nav-settings.actions';
import { patch } from '@ngxs/store/operators';
import { cloneDeep } from 'lodash';
import { SideNavSetting, SideNavSettingModel, TileType } from './types';

const defaults: SideNavSettingModel = {
  sideNavSettings: {},
};

@State<SideNavSettingModel>({
  name: 'sideNavSettings',
  defaults,
})
@Injectable()
export class SideNavSettingsState {
  static getSideNavSetting(
    userId: string,
  ): (state: SideNavSettingModel) => SideNavSetting {
    return createSelector(
      [SideNavSettingsState],
      (state: SideNavSettingModel) => {
        return state.sideNavSettings[userId];
      },
    );
  }

  static getIsSideNavCollapsed(
    userId: string,
  ): (state: SideNavSettingModel) => boolean {
    return createSelector(
      [SideNavSettingsState],
      (state: SideNavSettingModel) => {
        return !!state.sideNavSettings[userId].isCollapsed;
      },
    );
  }

  static getExpandedTile(
    userId: string,
  ): (state: SideNavSettingModel) => TileType | undefined {
    return createSelector(
      [SideNavSettingsState],
      (state: SideNavSettingModel) => {
        return state.sideNavSettings[userId].sideNavExpandedTile;
      },
    );
  }

  @Action(SetSideNavSetting)
  setSideNavSetting(
    ctx: StateContext<SideNavSettingModel>,
    { userId, sideNavSettings }: SetSideNavSetting,
  ): void {
    const state = ctx.getState();
    const sideNavSettingsToUpdate = cloneDeep(state.sideNavSettings);
    sideNavSettingsToUpdate[userId] = sideNavSettings;
    ctx.patchState({
      sideNavSettings: sideNavSettingsToUpdate,
    });
  }

  @Action(SetSideNavExpandedTile)
  setExpandedTileSetting(
    ctx: StateContext<SideNavSettingModel>,
    { userId, sideNavExpandedTile }: SetSideNavExpandedTile,
  ): void {
    ctx.setState(
      patch({
        sideNavSettings: patch({
          [userId]: patch({
            sideNavExpandedTile: sideNavExpandedTile,
          }),
        }),
      }),
    );
  }

  @Action(SetSideNavCollapsedStateSetting)
  setIsCollapsedSetting(
    ctx: StateContext<SideNavSettingModel>,
    { userId, isCollapsed }: SetSideNavCollapsedStateSetting,
  ): void {
    ctx.setState(
      patch({
        sideNavSettings: patch({
          [userId]: patch({
            isCollapsed: isCollapsed,
          }),
        }),
      }),
    );
  }
}
